var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weather"},[_c('iframe',{attrs:{"allowtransparency":"true","frameborder":"0","width":"210","height":"51","scrolling":"no","src":"//tianqi.2345.com/plugin/widget/index.htm?s=2&z=3&t=1&v=2&d=1&bd=0&k=&f=&ltf=009944&htf=cc0000&q=0&e=1&a=1&c=54511&w=200&h=51&align=right"}})])
}]

export { render, staticRenderFns }